module.exports = __webpack_public_path__ + "img/calendar.281d090b.png";